"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const faqs = [{
    id: 1,
    question: "Wat is een asbestattest en waarom heb ik het nodig?",
    answer: "Een asbestattest is een wettelijk verplicht document bij de verkoop van een woning die gebouwd is voor 2001. Het attest geeft aan of er asbest aanwezig is in uw woning en welke maatregelen nodig zijn."
  }, {
    id: 2,
    question: "Hoe lang duurt een asbestkeuring?",
    answer: "Een standaard asbestkeuring duurt gemiddeld 1 tot 2 uur, afhankelijk van de grootte en complexiteit van de woning. U ontvangt het officiële attest binnen 8 werkdagen na de keuring."
  }, {
    id: 3,
    question: "Wat kost een EPC-attest?",
    answer: "De prijs voor een EPC-attest varieert afhankelijk van de grootte van uw woning. Voor een appartement rekenen we €150. De prijs voor een woning tot 300m2 bedraagt €175."
  }, {
    id: 4,
    question: "Hoe vaak moet een elektriciteitskeuring uitgevoerd worden?",
    answer: "Bij de verkoop of verhuur van een woning is een elektriciteitskeuring verplicht. Als de installatie conform wordt gekeurd is de elektriciteitskeuring 25 jaar geldig. De prijs voor een elektriciteitskeuring is €170."
  }, {
    id: 5,
    question: "Kan ik meerdere keuringen tegelijk laten uitvoeren?",
    answer: "Ja, u kunt verschillende keuringen combineren zoals EPC, asbest en elektriciteit. Alle keuringen vinden op dezelfde dag plaats en u krijgt korting. Kijk gerust naar onze pakketprijzen."
  }, {
    id: 6,
    question: "Hoe plan ik een keuring in?",
    answer: "U kunt eenvoudig online een keuring aanvragen via onze website of bel ons op 0487412206. We plannen uw keuring binnen 3 werkdagen op een moment dat voor u past."
  }];
  return <section ref={ref} className={`bg-background py-20 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto max-w-4xl px-4">
        <div className="mb-12 text-center">
          <h2 className="text-foreground mb-4">Veelgestelde vragen</h2>
          <p className="text-foreground/70 text-lg">
            Vind snel antwoord op de meest gestelde vragen over onze keuringen
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="rounded-md border border-border bg-background shadow-soft transition-all duration-[150ms] hover:shadow-medium">
              <AccordionTrigger className="px-6 py-4 text-foreground hover:no-underline">
                <span className="text-left font-semibold">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 text-foreground/80">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}